<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-10-09 10:19:22
 * @LastEditors: DESKTOP-FKE5GMS\17601 1760178806@qq.com
 * @LastEditTime: 2023-11-23 16:45:14
 * @FilePath: \合联\oms\src\view\analysis\gccOrderStatistics\order.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/analysis/gccOrderStatistics";
export default {
  name: "",
  components: {
    cTable
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    data: {
      type: Object,
      default() {
        return {};
      }
    },
    headers: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  mounted() {
    this.header.searchs.splice(1, 0, ...this.headers);
    this.keys = this.data.keys;
    Object.keys(this.keys).forEach(key => {
      this.$refs["table"].list.push({
        title: this.keys[key].description
      });
    });
  },
  data() {
    return {
      methods: {
        ...apis,
        list: p => {
          return this.data.list(p);
        },
        beforeHandleList: ({ data, list }) => {
          Object.keys(this.keys).forEach(key => {
            list.push({
              title: this.keys[key].description
            });
            data.forEach(item => {
              list[list.length - 1][item.time] = item[key];
            });
          });
          this.fields.splice(2);
          data.forEach(item => {
            this.fields.push({
              name: item.time,
              key: item.time,
              minWidth: 100
            });
          });
          return list;
        }
      },
      config: {
        tabHeight: -30,
        slot: "div",
        isGetList: true
      },
      footer: {
        show: () => false
      },
      modals: {},
      header: {
        searchs: [],
        btns: {
          list: [
            {
              name: () => this.$tz("导出"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary"
              }
            },
            {
              name: () => this.$tz("详情,导出"),
              type: "detail",
              fnName: "detail",
              bind: {
                type: "primary"
              }
            }
          ],
          methods: {
            export: () => {
              let table = this.$refs["table"];
              table.selectAll = table.list;
              table.exportExc(this.$t(this.$route.name) + "-" + this.name);
            },
            detail({ searchForm }) {
              this.handleRequestMethods(
                "list",
                Object.assign({ export: 1 }, searchForm),
                false,
                true
              ).then(res => {
                this.$Message.success(res.msg);
              });
            }
          }
        }
      },
      fields: [
        {
          name: () => this.$tz("时间,|,Time"),
          key: "title",
          minWidth: 150,
          fixed: "left"
        }
      ]
    };
  }
};
</script>

<style scoped></style>
